import { CoreDataDictionaryViewsName } from './name';
import { deleteDataDictionaryView } from '@api';
import { removeCoreDataDictionaryViewSyncSlice } from './remove';
import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const deleteCoreDataDictionaryViewsAsyncSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [ removeCoreDataDictionaryViewSyncSlice.syncActionCreator ]
	},
	name: CoreDataDictionaryViewsName,
	receive: false,
	request: true,
	requestHandler: deleteDataDictionaryView,
	yieldType: SagaYieldType.Every
});
